import type { Chain, ChainId } from '@/types'

export const CHAINS: Record<number, Chain> = {
  1: {
    id: 1,
    name: 'Ethereum',
    shortName: 'ETH',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://ethereum-rpc.publicnode.com',
      'https://cloudflare-eth.com',
      'https://eth.drpc.org',
    ],
    blockExplorerUrl: 'https://etherscan.io',
  },
  137: {
    id: 137,
    name: 'Polygon',
    shortName: 'MATIC',
    nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
    rpcUrls: [
      'https://polygon-bor-rpc.publicnode.com',
      'https://polygon.drpc.org',
    ],
    blockExplorerUrl: 'https://polygonscan.com',
  },
  56: {
    id: 56,
    name: 'BNB Chain',
    shortName: 'BNB',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: [
      'https://bsc-dataseed1.binance.org',
      'https://bsc-dataseed2.binance.org',
      'https://bsc-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://bscscan.com',
  },
  43114: {
    id: 43114,
    name: 'Avalanche',
    shortName: 'AVAX',
    nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
    rpcUrls: [
      'https://api.avax.network/ext/bc/C/rpc',
      'https://avalanche-c-chain-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://snowscan.xyz',
  },
  42161: {
    id: 42161,
    name: 'Arbitrum One',
    shortName: 'ARB',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://arb1.arbitrum.io/rpc',
      'https://arbitrum-one-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://arbiscan.io',
  },
  10: {
    id: 10,
    name: 'Optimism',
    shortName: 'OP',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://mainnet.optimism.io',
      'https://optimism-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://optimistic.etherscan.io',
  },
  8453: {
    id: 8453,
    name: 'Base',
    shortName: 'BASE',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://mainnet.base.org',
      'https://base-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://basescan.org',
  },
  // ── Testnets ──────────────────────────────────────────────────────────────
  43113: {
    id: 43113,
    name: 'Avalanche Fuji',
    shortName: 'FUJI',
    nativeCurrency: { name: 'AVAX', symbol: 'AVAX', decimals: 18 },
    rpcUrls: [
      'https://api.avax-test.network/ext/bc/C/rpc',
      'https://avalanche-fuji-c-chain-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://testnet.snowscan.xyz',
  },
  84532: {
    id: 84532,
    name: 'Base Sepolia',
    shortName: 'BASE',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [
      'https://sepolia.base.org',
      'https://base-sepolia-rpc.publicnode.com',
    ],
    blockExplorerUrl: 'https://sepolia.basescan.org',
  },
  50: {
    id: 50,
    name: 'XDC Network',
    shortName: 'XDC',
    nativeCurrency: { name: 'XDC', symbol: 'XDC', decimals: 18 },
    rpcUrls: [
      'https://erpc.xinfin.network',
      'https://rpc.xinfin.network',
      'https://rpc1.xinfin.network',
    ],
    blockExplorerUrl: 'https://explorer.xinfin.network',
  },
  51: {
    id: 51,
    name: 'XDC Apothem',
    shortName: 'XDC',
    nativeCurrency: { name: 'XDC', symbol: 'XDC', decimals: 18 },
    rpcUrls: [
      'https://erpc.apothem.network',
      'https://rpc.apothem.network',
    ],
    blockExplorerUrl: 'https://apothem.blocksscan.io',
  },
}

export const SUPPORTED_CHAIN_IDS: ChainId[] = [1, 137, 56, 43114, 42161, 10, 8453, 43113, 84532, 50, 51]

export function getChain(chainId: number): Chain | null {
  return CHAINS[chainId] ?? null
}

export function isSupported(chainId: number): boolean {
  return chainId in CHAINS
}

export function chainToHex(chainId: number): string {
  return `0x${chainId.toString(16)}`
}
